/* eslint-disable eqeqeq */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from 'react';
import { useAuth } from 'contexts/auth-context';
import { Link, useHistory } from 'react-router-dom';
import qs from 'qs';
import Page from 'components/page/page';
import { attemptLogin, attemptSignup, attemptForgotPassword } from 'utils/api';

import './auth-styles.scss';

function Login() {
  const { setPrevPage, setUser, setUserID, setLoggedIn, resetPassword, setResetPassword } = useAuth();
  const [formType, setFormType] = useState('login');
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConf, setPasswordConf] = useState('');
  const [firstName, setFirstName] = useState('');
  const [zipCode, setZipCode] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessageStyle, setErrorMessageStyle] = useState("alert alert-danger");
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();


  // Determine initial form type based on URL parameters
  useEffect(() => {
    const { screenHint } = qs.parse(window.location.search.slice(1));
    const isSignup = screenHint == 'signup' || window.location.pathname.includes('signup');
    setFormType(isSignup ? 'signup' : 'login');
    setErrorMessage('')
  }, []);


  // Handle form switching between login and signup
  const handleFormSwitch = (type) => {
    setFormType(type);
    setErrorMessage('');
  };
  // Handle forgot password submission
  const forgotPassword = (e) => {
    e.preventDefault();
    setResetPassword(true);
  };


  // Submit password reset request
  const submitResetPassword = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    console.log("submitResetPassword", e)
    try {
      const resetRes = await attemptForgotPassword(email);
      console.log("resetRes", resetRes)

      if (resetRes.Success) {
        setErrorMessage(resetRes.Message);
        setErrorMessageStyle("alert alert-success")
        setTimeout(() => history.push('/login'), 2000);
      } else {
        setErrorMessage(resetRes.Message || 'Failed to send reset email.');
      }
    } catch (error) {
      setErrorMessage('An error occurred. Please try again.');
    }
    setIsLoading(false);
  };

  // Handle login submission
  const submitLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const userResponse = await attemptLogin(email, password);
      if (userResponse.Success) {
        setUser(userResponse);
        setUserID(userResponse.UUID);
        setLoggedIn(true);
        setPrevPage('authLogin');
        if (window.ReactNativeWebView) {
          window.ReactNativeWebView.postMessage(`userID:${userResponse.UUID}`);
        }
        // window.location.href = '/';
        history.push('/');
      } else {
        setErrorMessage(userResponse.Message || 'Login failed.');
      }
    } catch (error) {
      setErrorMessage('An error occurred during login.');
    }
    setIsLoading(false);
  };

  const submitSignup = async (e) => {
    e.preventDefault();
    if (password !== passwordConf) {
      setErrorMessage('Passwords do not match.');
      return;
    }
    setIsLoading(true);
    try {
      const userResponse = await attemptSignup(email, password, firstName, zipCode);
      if (userResponse.Success) {
        setUser(userResponse);
        setUserID(userResponse.UUID);
        setLoggedIn(true);
        setPrevPage('authLogin');
        history.push('/redeem');
      } else {
        setErrorMessage(userResponse.Message || 'Signup failed.');
      }
    } catch (error) {
      setErrorMessage('An error occurred during signup.');
    }
    setIsLoading(false);
  };



  return (
    <Page>
      <div className="login-container">
        <div className="col-sm-offset-4 login-box">
          <div className="login-header">
            <img src="header-logo1.png" alt="Hannaford" />
            <h3>Hannaford Helps Schools</h3>
          </div>
          {resetPassword ? (
            <div>
              <div className="reset-pw-form" id="loginButton">
                Reset Your Password
              </div>
              <hr />
              {errorMessage && <div className={errorMessageStyle}>{errorMessage}</div>}
              <form onSubmit={submitResetPassword} id="loginForm">
                <div className="form-group ">
                  <label htmlFor="name">
                    Enter your email to receive a link to reset your password.
                  </label>
                  <div className="input-icon">
                    <i className="fa fa-envelope icon" />
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Enter your email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                </div>{' '}
                <div className="captcha-container form-group" />
                <hr />
                <button type="submit" className="btn btn-danger btn-block" disabled={isLoading}>
                  {isLoading ? 'Processing...' : 'Reset Password'}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary btn-block"
                  onClick={() => { setErrorMessage() 
                    setResetPassword(false)}}
                >
                  Back
                </button>
              </form>
            </div>
          ) : (
            <div>
              <div className="login-signup-selection">
                <div className="buttonDiv selected " id="loginButton">
                  <button type="submit" className={`btn ${formType === 'login' ? 'selected' : ''}`} onClick={() => handleFormSwitch('login')}>
                    Log In
                  </button>
                  <button type="submit" className={`btn ${formType === 'signup' ? 'selected' : ''}`} onClick={() => handleFormSwitch('signup')}>
                    Sign Up
                  </button>
                </div>
              </div>
              {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}

              {formType === 'login' ? (
                <form onSubmit={submitLogin} id="loginForm">
                  <div className="form-group ">
                    <label htmlFor="name">Email</label>
                    <div className="input-icon">
                      <i className="fa fa-envelope icon" />
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Enter your email"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />

                    </div>
                  </div>{' '}
                  <div className="form-group">
                    <label htmlFor="name">Password</label>
                    <div className="input-icon">
                      <i className="fa fa-lock icon" />
                    </div>
                    <input type="password" id="password" className="form-control" placeholder="Enter your password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                    {/* <button type="button" className="passwordButton" onClick={() => setShowPassword(!showPassword)}>
                      {showPassword ? "Hide password" : "Show password"}
                    </button> */}
                  </div>
                  <div className="captcha-container form-group" />
                  <hr />

                  <button type="submit" className="btn btn-danger btn-block" disabled={isLoading}>
                    {isLoading ? 'Logging in...' : 'Log In'}
                  </button>
                  <div className="captcha-container form-group">
                    <button type="button" className="btn btn-link reset-pw" onClick={() => setResetPassword(true)}>
                      Forgot your password?
                    </button>
                  </div>
                </form>
              ) : (
                <form onSubmit={submitSignup} id="signupForm">
                  <div className="form-group">
                    <label htmlFor="name">Email</label>
                    <div className="input-icon">
                      <i className="fa fa-envelope icon" />
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder="Enter your email"
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Password</label>
                    <div className="input-icon">
                      <i className="fa fa-lock icon" />
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        placeholder="Enter your password"
                        minLength={6}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Password Confirmation</label>
                    <div className="input-icon">
                      <i className="fa fa-lock icon" />
                      <input
                        type="password"
                        className="form-control"
                        id="passwordConf"
                        placeholder="Confirm your password"
                        value={passwordConf}
                        onChange={(e) => setPasswordConf(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">First Name</label>
                    <div className="input-icon">
                      <i className="fa fa-user icon" />
                      <input
                        type="firstName"
                        className="form-control"
                        id="firstName"
                        placeholder="Enter your first name"
                        value={firstName}
                        onChange={(e) => setFirstName(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="form-group">
                    <label htmlFor="name">Zip Code</label>
                    <div className="input-icon">
                      <i className="fa-solid fa-map-location icon" />
                      <input
                        type="zipCode"
                        className="form-control"
                        id="zipCode"
                        placeholder="Enter your zip code"
                        value={zipCode}
                        onChange={(e) => setZipCode(e.target.value)}
                        required
                      />
                    </div>
                  </div>
                  <div className="captcha-container form-group" />
                  <button
                    type="submit"
                    id="btn-signup"
                    className="btn btn-danger btn-block"
                    disabled={isLoading}
                  >
                    {isLoading ? 'Signing up...' : 'Sign Up'}
                  </button>
                  <hr />
                </form>
              )}
            </div>

          )}
        </div>
      </div>
    </Page>
  );
}
export default Login;
